import Swiper, { Navigation, Lazy, Pagination, EffectFade } from "swiper";
import GoogleMap from "../utils/map";
import { MarkerClusterer } from "@googlemaps/markerclusterer";



const BrandOpen = {
  init() {

    BrandOpen.logoSlider();
    BrandOpen.storesImageSlider();
    BrandOpen.renderMap();
  },

  renderMap() {
    const mapEl = $("#map-wrap");

    if (!mapEl.length) {
      return;
    }

    const data = {
      lat: mapEl.data("lat"),
      lng: mapEl.data("lng"),
      zoom: mapEl.data("zoom"),
    };

    GoogleMap.create(data, mapEl);


  },


  logoSlider() {
    const storeEl = $(".logo-slider");
    if (!storeEl.length) {
      return;
    }

    const navPrev = storeEl.find(".swiper-button--prev");
    const navNext = storeEl.find(".swiper-button--next");


    if (storeEl.length) {
      new Swiper(storeEl.find(".logo-slider__logos-slider")[0], {
        modules: [Navigation],
        slidesPerView: "auto",
        spaceBetween: 5,
        initialSlide: 1,
        loop: true,
        navigation: {
          prevEl: navPrev[0],
          nextEl: navNext[0],
        },
        breakpoints: {
          600: {
            spaceBetween: 10,
          }
        }

      })
    }
  },

  storesImageSlider() {
    const storeEl = $(".stores");
    if (!storeEl.length) {
      return;
    }

    const navPrev = storeEl.find(".swiper-button--prev");
    const navNext = storeEl.find(".swiper-button--next");


    if (storeEl.length) {
      new Swiper(storeEl.find(".stores__image-slider")[0], {
        modules: [Navigation, Pagination, EffectFade],
        slidesPerView: 1,
        spaceBetween: 20,
        EffectFade: true,
        loop: true,
        navigation: {
          prevEl: navPrev[0],
          nextEl: navNext[0],
        },
        pagination: {
          el: storeEl.find(".swiper-pagination")[0],
          clickable: true,
        }

      })
    }
  },
}

export default BrandOpen;
